import { Box, fade, Theme, withStyles } from '@material-ui/core';

export const OverlayBox = withStyles(({ palette }: Theme) => ({
  root: {
    background: fade(palette.common.white, 0.8),
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(Box);

export const ScrollBox = withStyles(({ spacing }: Theme) => ({
  root: {
    overflowX: 'auto',
    paddingBottom: spacing(2),
  },
}))(Box);

export const RelativeBox = withStyles(() => ({
  root: {
    position: 'relative',
    minHeight: 200,
    minWidth: 300,
  },
}))(Box);

export default {
  OverlayBox,
};
